import axios from 'axios';

import {
  URL_SERVIDOR_IMPRESSORA,
  URL_SERVIDOR_IMPRESSORA_NOVO,
} from '../../utils';
import api from '../api';

const apiAntigaImpressora = axios.create({
  baseURL: URL_SERVIDOR_IMPRESSORA,
});

const apiNovaImpressora = axios.create({
  baseURL: URL_SERVIDOR_IMPRESSORA_NOVO,
});

async function imprimirServicoAntigo(id, type, query) {
  try {
    const url = `/imprimir-document/${id}/${type}${query}`;
    await apiAntigaImpressora.post(url, {
      url_api: process.env.REACT_APP_HOST_API,
    });
    return 1;
  } catch (e) {
    return -1;
  }
}

async function imprimirServicoNovo(id, tipo, comandos) {
  try {
    const url = `/imprimir`;
    const response = await apiNovaImpressora.post(url, {
      id: String(id),
      tipo,
      comandos,
    });
    const { status, message, data } = response.data;
    return 1;
  } catch (e) {
    return -1;
  }
}

async function buscarDadosImpressao(id, tipo) {
  const response = await api.get(
    `/gerar_documentos_impressora_termica_novo_formato/${id}/${tipo}`,
  );

  return response.data;
}

export { imprimirServicoAntigo, imprimirServicoNovo, buscarDadosImpressao };
